module.exports = __webpack_public_path__ + "img/bg_about_experience3.33c20b2b.png";